/** Column name the quotes list may sort by (contact name uses a sentinel) */
export const QUOTE_CONTACT_NAME_SORT_COLUMN = `contactName`;
//# sourceMappingURL=quote.js.map